module.exports = __webpack_public_path__ + "img/white_logo.0afc00b3.svg";